import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faTimesCircle, faMapMarkerAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import {
  ActionFooter,
  CancelBtn,
  ContentArea,
  ErrorBanner,
  GenerateBtn,
  Icon,
  LocationCard,
  LocationCheckboxWrapper,
  LocationHeader,
  LocationIconWrapper,
  LocationInfo,
  LocationTitle,
  ModalHeader,
  ModalWindow,
  ModalWrapper,
  SelectionSummary,
  StyledModalContent,
  SummaryText,
  WashroomCount,
} from "./styles";
import { WashroomLogsReportModalProps } from "./types";
import Checkbox from "src/components/Checkbox";
import { colors } from "src/styles";

const GenerateWashroomLogsReportModal = ({
  closeModal,
  defaultValues,
  onSubmit,
  errorMsg,
}: WashroomLogsReportModalProps) => {
  const [selectedLocations, setSelectedLocations] = useState<Record<string, boolean>>({});
  const [selectedWashrooms, setSelectedWashrooms] = useState<Record<string, boolean>>({});
  const [selectAllActive, setSelectAllActive] = useState(false);

  const handleLocationChange = (location: string, washrooms: any[]) => {
    const isChecked = !selectedLocations[location];
    setSelectedLocations((prev) => ({ ...prev, [location]: isChecked }));

    const washroomUpdates: Record<string, boolean> = {};
    washrooms.forEach((washroom) => {
      washroomUpdates[washroom.id] = isChecked;
    });
    setSelectedWashrooms((prev) => ({ ...prev, ...washroomUpdates }));
  };

  // const handleWashroomChange = (washroomId: string, location: string, washrooms: any[]) => {
  //   const isChecked = !selectedWashrooms[washroomId];
  //   setSelectedWashrooms((prev) => ({ ...prev, [washroomId]: isChecked }));

  //   const allWashroomsSelected = washrooms.every((w) => (w.id === washroomId ? isChecked : selectedWashrooms[w.id]));
  //   setSelectedLocations((prev) => ({ ...prev, [location]: allWashroomsSelected }));
  // };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Transform selectedWashrooms into WashroomsLogsReportChecklistValues shape
    const selectedByLocation: Record<string, { washrooms: any[] | undefined; locationId: string }> = {};
    if (defaultValues) {
      Object.entries(defaultValues).forEach(([location, { washrooms, locationId }]) => {
        // Only include locations that are selected
        if (selectedLocations[location]) {
          let selectedWashroomDetails: any[] | undefined = undefined;
          if (Array.isArray(washrooms)) {
            selectedWashroomDetails = washrooms.filter((w) => selectedWashrooms[w.id]);
          }
          selectedByLocation[location] = {
            washrooms: selectedWashroomDetails,
            locationId: locationId,
          };
        }
      });
    }
    onSubmit?.(selectedByLocation);
    closeModal();
  };

  const selectAllLocations = () => {
    const newSelectAllState = !selectAllActive;
    setSelectAllActive(newSelectAllState);

    if (defaultValues) {
      const allLocations: Record<string, boolean> = {};
      const allWashrooms: Record<string, boolean> = {};
      Object.entries(defaultValues).forEach(([location, { washrooms }]) => {
        allLocations[location] = newSelectAllState;
        if (Array.isArray(washrooms)) {
          washrooms.forEach((washroom) => {
            allWashrooms[washroom.id] = newSelectAllState;
          });
        }
      });
      setSelectedLocations(allLocations);
      setSelectedWashrooms(allWashrooms);
    }
  };

  const totalLocations = defaultValues ? Object.keys(defaultValues).length : 0;
  const selectedCount = Object.values(selectedLocations).filter(Boolean).length;

  return (
    <ModalWrapper>
      <ModalWindow style={{ maxWidth: "520px" }}>
        <ModalHeader>
          <div>
            <span>Generate Washroom Logs Report</span>
            <Icon onClick={closeModal} icon={faTimesCircle as IconProp} />
          </div>
        </ModalHeader>
        <StyledModalContent>
          <form onSubmit={handleSubmit}>
            <SelectionSummary>
              <SummaryText>
                {selectedCount} washroom{selectedCount !== 1 ? "s" : ""} selected across {totalLocations} location
                {totalLocations !== 1 ? "s" : ""}
              </SummaryText>
              <Checkbox
                checked={selectAllActive}
                label="Select All"
                onChange={() => selectAllLocations()}
                containerStyle={`
                  justify-content: flex-end;
                  font-size: 13px;
                  font-weight: 500;
                  color: ${colors.kleenway.green};
                  width: auto;
                `}
                checkboxStyle={`
                  width: 22px;
                  height: 22px;
                `}
              />
            </SelectionSummary>

            <ContentArea>
              {defaultValues &&
                Object.entries(defaultValues).map(
                  ([location, { washrooms }]: [string, { washrooms: any[] | undefined }]) => {
                    const hasSelection =
                      Array.isArray(washrooms) && washrooms.some((w: { id: string }) => selectedWashrooms[w.id]);

                    return (
                      <LocationCard key={location} $hasSelection={hasSelection}>
                        <LocationHeader>
                          <LocationInfo>
                            <LocationIconWrapper>
                              <FontAwesomeIcon icon={faMapMarkerAlt as IconProp} />
                            </LocationIconWrapper>
                            <LocationTitle>{location}</LocationTitle>
                            <WashroomCount>
                              {washrooms ? washrooms.length : 0} washroom
                              {washrooms && washrooms.length !== 1 ? "s" : ""}
                            </WashroomCount>
                          </LocationInfo>
                          <LocationCheckboxWrapper>
                            <Checkbox
                              checked={!!selectedLocations[location]}
                              label="Select"
                              onChange={() => handleLocationChange(location, washrooms ?? [])}
                              containerStyle={`
                              justify-content: flex-start;
                              font-size: 13px;
                              font-weight: 500;
                              color: ${colors.kleenway.green};
                            `}
                              checkboxStyle={`
                              width: 22px;
                              height: 22px;
                            `}
                            />
                          </LocationCheckboxWrapper>
                        </LocationHeader>

                        {/* {Array.isArray(washrooms) && washrooms.length > 0 && (
                        <WashroomGrid>
                          {washrooms.map((washroom) => (
                            <WashroomCard key={washroom.id} $isSelected={!!selectedWashrooms[washroom.id]}>
                              <Checkbox
                                checked={!!selectedWashrooms[washroom.id]}
                                label={washroom.label}
                                onChange={() => handleWashroomChange(washroom.id, location, washrooms)}
                                containerStyle={`
                                  justify-content: flex-start;
                                  font-size: 14px;
                                  color: ${colors.grey.dark};
                                  width: 100%;
                                `}
                                checkboxStyle={`
                                  width: 24px;
                                  height: 24px;
                                `}
                              />
                            </WashroomCard>
                          ))}
                        </WashroomGrid>
                      )} */}
                      </LocationCard>
                    );
                  },
                )}

              {errorMsg && <ErrorBanner>{errorMsg}</ErrorBanner>}
            </ContentArea>

            <ActionFooter>
              <CancelBtn type="button" onClick={closeModal}>
                Cancel
              </CancelBtn>
              <GenerateBtn type="submit" disabled={selectedCount === 0}>
                {`Generate Report (${selectedCount})`}
              </GenerateBtn>
            </ActionFooter>
          </form>
        </StyledModalContent>
      </ModalWindow>
    </ModalWrapper>
  );
};

export default GenerateWashroomLogsReportModal;
